import './Philosophy.css';

function AboutPhilosophy() {
  return (
    <div className="philosophy-container">

      <h2>기업이념</h2>
      {/* 핵심가치 요약 이미지 */}
      <div className="ideology-image-wrapper">
        <img
          src="/images/Philosophy.png"
          alt="TAMA 핵심가치"
          className="ideology-image"
        />
      </div>

      {/* 비전/미션 */}
      <div className="overview-table">
        <div className="overview-row">
          <div className="overview-title">비전</div>
          <div className="overview-value">
            우리는 모든 산업 제어 문제를 해결하는 최고의 기술 파트너를 지향합니다.
          </div>
        </div>
        <div className="overview-row">
          <div className="overview-title">미션</div>
          <div className="overview-value">
            산업 전반에 걸쳐 신뢰할 수 있는 제어 솔루션을 제공합니다.
          </div>
        </div>
      </div>

      {/* 핵심가치 상세 설명 */}
      <h3 style={{ paddingTop: '40px' }}>T·A·M·A 핵심가치</h3>
      <div className="overview-table">
        <div className="overview-row">
          <div className="overview-title">T - 생각하라</div>
          <div className="overview-value">모든 곳에는 문제가 존재하며, 우리는 반드시 해결책을 찾을 수 있다고 믿습니다.</div>
        </div>
        <div className="overview-row">
          <div className="overview-title">A - 움직여라</div>
          <div className="overview-value">해결책을 위해 현장을 조사하고, 자료를 수집하며 끊임없이 준비합니다.</div>
        </div>
        <div className="overview-row">
          <div className="overview-title">M - 만들어라</div>
          <div className="overview-value">문제 해결을 위한 최적의 솔루션을 설계하고 구현합니다.</div>
        </div>
        <div className="overview-row">
          <div className="overview-title">A - 완성하라</div>
          <div className="overview-value">제공한 솔루션을 지속적으로 개선하며, 완성도 높은 결과물을 만들어냅니다.</div>
        </div>
      </div>

    </div>
  );
}

export default AboutPhilosophy;
